import { css } from '@emotion/css';
import { theme } from 'core/theme';

export const socialMediaIcons = css`
  display: flex;
  justify-content: center;
  padding: ${theme.spacing(1)};
`;

export const linkedinIcon = css`
  width: 2rem;
  height: 2rem;
`;
